export default {
  attributes: {
    /* Article */
    category: 'Article Group',
    name: 'Name',
    productGroup: 'Product Group',
    orderLevel: 'Order Level',
    price: 'Price',
    priceMax: 'Price Max',
    priceMin: 'Price Min',
    quantity: 'Quantity',
    type: 'Article Type',

    /* Stock Item */
    cost: 'Buying Price',
    size: 'Size',
    unit: 'Unit',
    managementGroup: 'Management Group',
    count: 'Count',
    alarmLevel: 'Alarm Level',
    standardOrder: 'Reorder',
    stockItemId: 'Stock Item',
    stockItemName: 'Item Name',

    /* Promotion */
    promotionType: 'Promotion Type',
    value: 'Value',
    subValue: 'Sub Value',
    fromDate: 'From',
    toDate: 'To',
    startTime: 'Start Time',
    endTime: 'End Time',
    dayOfWeek: 'Day of week',
  },
  messages: {
    decimal: (field) => {
      const fieldName = field.includes('quantity') ? 'Quantity' : field;
      return `${fieldName} is invalid`;
    },
    max_value: (field, [value]) => {
      const fieldName = field.includes('quantity') ? 'Quantity' : field;
      return `${fieldName} must be less than ${value}`;
    },
    numeric: (field) => {
      const fieldName = field.includes('quantity') ? 'Quantity' : field;
      return `${fieldName} is invalid`;
    },
    required: field => `Please, enter ${field}`,
    required_if: field => `Please, enter ${field}`,
  },
};
